import { Grid, MenuItem } from '@mui/material'
import React from 'react'
import InputDatePicker from '../input/inputDatePicker'
import AutocompleteSelect from '../select/autoCompleteSelect'
import FilterSelect from '../select/filterSelect'
import moment from 'moment'
import { getYearOptions } from '../../utils/app.utils'

type Props = {
    folderName: any
    sdate: string
    setSdate: any
    edate: string
    setEdate: any
    inputFolder: any
    setInputFolder: any
    setLevel2: any
    setLevel3: any
    setLevel4: any
    setLevelFiles: any
    keywordLevel1: string
    setKeywordLevel1: any
    keywordLevel2: string
    setKeywordLevel2: any
    keywordLevel3: string
    setKeywordLevel3: any
    keywordLevel4: string
    setKeywordLevel4: any
    idFiscalYear: string
    setIdFiscalYear: any
}

export default function FilterFolder(props: Props) {
        const yearOptions = getYearOptions();
    
    const {
        folderName,
        sdate,
        edate,
        setSdate,
        setEdate,
        inputFolder,
        setInputFolder,
        setLevel2,
        setLevel3,
        setLevel4,
        setLevelFiles,
        keywordLevel1,
        setKeywordLevel1,
        keywordLevel2,
        setKeywordLevel2,
        keywordLevel3,
        setKeywordLevel3,
        keywordLevel4,
        setKeywordLevel4,
        idFiscalYear,
        setIdFiscalYear
    } = props
    return (
        <Grid container columns={15} sx={{ marginBottom: '12px', display: { lg: 'flex', xs: 'none' } }}>
            <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>
                <InputDatePicker
                    dateFormat="DD/MM/YYYY"
                    required={false}
                    key={""}
                    disabled={false}
                    label=""
                    maxDate={edate}
                    value={sdate}
                    onClear={() => setSdate('')}
                    onChange={(e: any) => {
                        setSdate(moment(e).format("YYYY-MM-DD"))
                        setInputFolder({ ...inputFolder, idReferFolder: null, stepView: 1 })
                        setLevel2(null)
                        setLevel3(null)
                        setLevel4(null)
                        setLevelFiles(null)
                    }
                    }
                    allowClear
                    heading={'ตั้งแต่วันที่'} />
            </Grid>
            <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>

                <InputDatePicker
                    dateFormat="DD/MM/YYYY"
                    required={false}
                    key={""}
                    disabled={false}
                    label=""
                    minDate={sdate}
                    value={edate}
                    onClear={() => setEdate('')}
                    onChange={(e: any) => {
                        setEdate(moment(e).format("YYYY-MM-DD"))
                        setInputFolder({ ...inputFolder, idReferFolder: null, stepView: 1 })
                        setLevel2(null)
                        setLevel3(null)
                        setLevel4(null)
                        setLevelFiles(null)
                    }
                    }
                    allowClear
                    heading={'ถึงวันที่'} />
            </Grid>
            <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>

                <AutocompleteSelect
                    options={folderName?.level1}
                    // disabled={location.state.params.isView}
                    getOptionLabel={(option: any) => option}
                    labelId="addmin-type"
                    inputValue={keywordLevel1}
                    heading={'ตู้เอกสาร/หน่วยงาน'}
                    placeholder='ทั้งหมด'
                    onInputChange={(event, newValue) => {
                        setKeywordLevel1(newValue)
                        setInputFolder({ ...inputFolder, idReferFolder: null, stepView: 1 })
                        setLevel2(null)
                        setLevel3(null)
                        setLevel4(null)
                        setLevelFiles(null)
                    }}
                    // required
                    helperText={''}
                />
            </Grid>
            <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>

                <AutocompleteSelect
                    options={folderName?.level2}
                    // disabled={location.state.params.isView}
                    getOptionLabel={(option: any) => option}
                    labelId="addmin-type"
                    inputValue={keywordLevel2}
                    heading={'ชั้นเอกสาร'}
                    placeholder='ทั้งหมด'
                    onInputChange={(event, newValue) => {
                        setKeywordLevel2(newValue)
                        setInputFolder({ ...inputFolder, idReferFolder: null, stepView: 1 })
                        setLevel2(null)
                        setLevel3(null)
                        setLevel4(null)
                        setLevelFiles(null)
                    }}
                    // required
                    helperText={''}
                />
            </Grid>
            <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>

                <AutocompleteSelect
                    options={folderName?.level3}
                    // disabled={location.state.params.isView}
                    getOptionLabel={(option: any) => option}
                    labelId="addmin-type"
                    inputValue={keywordLevel3}
                    heading={'แฟ้มเอกสาร'}
                    placeholder='ทั้งหมด'
                    onInputChange={(event, newValue) => {
                        setKeywordLevel3(newValue)
                        setInputFolder({ ...inputFolder, idReferFolder: null, stepView: 1 })
                        setLevel2(null)
                        setLevel3(null)
                        setLevel4(null)
                        setLevelFiles(null)
                    }}
                    // required
                    helperText={''}
                />
            </Grid>
            <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>
                <AutocompleteSelect
                    options={folderName?.level4}
                    // disabled={location.state.params.isView}
                    getOptionLabel={(option: any) => option}
                    labelId="addmin-type"
                    inputValue={keywordLevel4}
                    heading={'ประเภทเอกสาร'}
                    placeholder='ทั้งหมด'
                    onInputChange={(event, newValue) => {
                        setKeywordLevel4(newValue)
                        setInputFolder({ ...inputFolder, idReferFolder: null, stepView: 1 })
                        setLevel2(null)
                        setLevel3(null)
                        setLevel4(null)
                        setLevelFiles(null)
                    }}
                    // required
                    helperText={''}
                />
            </Grid>
            <Grid md={2} xs={12} >
                <FilterSelect heading='ปีงบประมาณ' labelId='' selectId='' options={[{ value: 'all', name: 'ทั้งหมด' }, ...yearOptions].map((x, i) => {
                    return (
                        <MenuItem key={i}
                            value={x.value}
                        >
                            {x.name}
                        </MenuItem>
                    )
                })} value={idFiscalYear} onchange={(e: any) => {
                    setIdFiscalYear(e.target.value)
                    setInputFolder({ ...inputFolder, idReferFolder: null, stepView: 1 })
                    setLevel2(null)
                    setLevel3(null)
                    setLevel4(null)
                    setLevelFiles(null)
                }} />
            </Grid>
        </Grid>
    )
}
